import * as Api from '@ViewModels';
import { IPrizeLog } from '@ViewModels';
import { css } from 'aphrodite';
import moment from 'moment';
import * as React from 'react';
import { getDisplayName } from '../../../../../models/NameUtils';
import { Checkbox } from '../../../../../web/components-v2/Checkbox';
import { Label } from '../../../../../web/components-v2/Label';
import { SlotMachineSymbol } from '../../../../components/slotMachines/SlotMachineSymbol';
import { styleSheet } from '../styles';

interface IProps {
	item: IPrizeLog;
	setGameTokenAsPaid?: (gameTokenId: string) => void;
}

const SYMBOL_HEIGHT_PX = 20;

export const ListItem: React.FC<IProps> = ({ item, setGameTokenAsPaid }) => {
	const gameData = item?.gameToken;
	const gameOutcome = gameData?.gameOutcome;
	const paid = Boolean(gameOutcome?.prizePaid);
	const date = gameData?.redemptionDate ? moment(gameData.redemptionDate).format('MM/DD/YYYY') : 'Undefined';
	const checkboxId = `paid-prize-${gameData.id}`;

	const handleChangePaid = () => {
		if (!paid) {
			setGameTokenAsPaid?.(gameData.id);
		}
	};

	return (
		<div className={css(styleSheet.card)}>
			<div className={css(styleSheet.cardName)}>{getDisplayName(gameData?.creator)}</div>
			<div className={css(styleSheet.cardPrize)}>{gameOutcome?.prize}</div>
			<div className={css(styleSheet.cardSymbols)}>
				{gameOutcome?.spinResult?.map((symbol: Api.SlotMachineSymbol, index: number) => (
					<span className={css(styleSheet.symbolChip)} key={index}>
						<SlotMachineSymbol type={symbol} style={{ height: SYMBOL_HEIGHT_PX, width: 'auto' }} />
					</span>
				))}
			</div>
			<div className={css(styleSheet.cardText)}>
				<span className={css(styleSheet.cardTextTitle)}>WHEN:</span> {date}
			</div>
			<div className={css(styleSheet.cardText)}>
				<span className={css(styleSheet.cardTextTitle)}>FOR:</span> {item?.achievementDescription || 'Undefined'}
			</div>
			<div className={css(styleSheet.cardPaid)}>
				<Label htmlFor={checkboxId} styles={[styleSheet.paidLabel]}>
					<Checkbox checked={paid} disabled={paid} id={checkboxId} onCheckedChange={handleChangePaid} />
					Paid
				</Label>
			</div>
		</div>
	);
};
